export default __webpack_public_path__ + "static/media/modelo_importacao_vidas.20f97a5f.csv";